import { combineReducers, configureStore } from "@reduxjs/toolkit";
import generalReducer from "../slices/generalSlice";
import ordersReducer from "../slices/ordersSlice";
import userReducer from "../slices/userSlice";

const rootReducer = combineReducers({
  general: generalReducer,
  orders: ordersReducer,
  user: userReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
